export const badges: string[] = [
  "boulder-badge",
  "cascade-badge",
  "thunder-badge",
  "rainbow-badge",
  "soul-badge",
  "marsh-badge",
  "volcano-badge",
  "earth-badge",
];
